import { Component, HostListener, signal, computed, OnInit } from "@angular/core";
import { NavigationStart, Router, RouterLink } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { ModalAlterarPerfil } from "components/modal-alterar-perfil/modal-alterar-perfil.component";
import { RelogioPontoComponent } from "components/relogio-ponto/relogio-ponto.component";
import { SinoComponent } from "components/sino/sino.component";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { authConfig } from "src/app/shared/auth/models/auth.config";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { ListarEncaminhados } from "src/app/shared/models/chamados/listar-encaminhados";
import { DefaultResponse } from "src/app/shared/models/DefaultResponse";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { AgendamentoService } from "src/app/shared/services/agendamento.service";
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { RelogioPontoService } from "src/app/shared/services/modal-relogioPonto.service";
import { NotificacoesService } from "src/app/shared/services/notificacoes.service";
import { PerfilService } from "src/app/shared/services/perfil.service";
import { angularCommonImports } from "src/app/shared/ui/angular-common";
import { environment } from "src/environments/environment";
import { ModalComponent } from "../../../../../components/modal/modal.component";
import { HeaderGovBrComponent } from "../header-gov-br/header-gov-br.component";
import { EscolaService } from "src/app/shared/services/escola.service";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { ParametroPeriodoService } from 'src/app/shared/services/parametro-periodo.service';
import { authConfigMasp } from "src/app/shared/auth/models/auth-masp.config";
import {
  possuiEscolaCivicoMilitarVinculada,
} from "src/app/pages/civico-militar/utils/civico-militar-access.helper";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [ModalComponent, ModalAlterarPerfil, SinoComponent, RelogioPontoComponent, HeaderGovBrComponent, angularCommonImports, RouterLink]
})

export class HeaderComponent implements OnInit {
  private activeSubMenus: { [key: string]: boolean } = {};
  private podeVisualizarCivico = signal<boolean>(false);
  public podeVisualizarCivicoMilitarPro = computed(() => this.podeVisualizarCivico());

  @HostListener('window:click', ['$event'])
  click(event: MouseEvent) {
    const divClicada = event.target as HTMLElement;
    const notificacoes = document.getElementsByClassName("sidebar-notificacao").item(0) as HTMLElement;
    const bodyoverlay = document.getElementsByTagName("body").item(0) as HTMLElement;
    if (
      !divClicada.classList.contains('sidebar-notificacao') &&
      divClicada.id != "sino-notificacao") {
      if (this.userLogado?.funcionalidades.includes(16)) {
        // notificacoes.className = "sidebar-notificacao";
      }
      bodyoverlay.className = "";
      this.expandir = !this.expandir;
    }
  }

  private async verificarPermissaoCivicoMilitar() {
    const temFuncionalidades = (this.userLogado?.funcionalidades?.filter((x: number) => [29, 30, 31, 32, 33].includes(x)).length ?? 0) > 0;
    let temComportamento = false;

    if (this.atribuicoesLogin?.NumeroComportamento == 3 || this.atribuicoesLogin?.NumeroComportamento == 4) {
      temComportamento = await possuiEscolaCivicoMilitarVinculada(this.userLogado, this.escolaService);
    }

    if (this.atribuicoesLogin?.NumeroComportamento == 1 || this.atribuicoesLogin?.NumeroComportamento == 2) {
      temComportamento = true;
    }

    this.podeVisualizarCivico.set(temFuncionalidades && temComportamento);
  }

    userPodeVisualizarCivicoMilitar(): boolean {
        return (this.userLogado?.funcionalidades?.filter((x: number) => [29, 30, 31, 32].includes(x)).length ?? 0) > 0 && this.podeVisualizarCivicoMilitarPro();
    }

    public get Perfil(): typeof Perfil {
        return Perfil;
    }


  public expandir: boolean = false;
  public versao: string = "";
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;
  public showModalAgendamento: boolean = false;
  public showModalAgendamentoPsicologo: boolean = false;
  public showModalRegistroJornada: boolean = false;
  public showModalRegistroFimJornada: boolean = false;
  public quantidadeAgendamentosAbertos: string;
  public showModalPerfil: boolean;
  public podeVisualizarMenuPsicologos: boolean = false;
  public temPlanoContingenciaAtivo = false;
  public temPmceAtivo = false;
  public podeVisualizarCivicoMilitar: boolean = false;

  constructor(
    private oauthService: OAuthService,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private spinnerService: NgxSpinnerService,
    private perfilService: PerfilService,
    private ConvivaErrors: ConvivaErrorHandlingService,
    private notificacoesService: NotificacoesService,
    private agendamentoService: AgendamentoService,
    private relogioPontoService: RelogioPontoService,
    private parametroPeriodoService: ParametroPeriodoService,
    private escolaService: EscolaService
  ) {
    this.configure();
    this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  public submitted = false;
  public lstNotificacoes: ListarChamados[] = [];

  private configure() {
    this.oauthService.configure(authConfig);
  }

  onClickRegistrarEntradaMenu() {
    this.FecharMenu();
    this.userLogado = this.authService.getUser();
    if (!this.podeRegistrarPonto()) {
      this.toastr.error("Para registrar o ponto é necessário estar vinculado a uma escola e diretoria, ou selecionar apenas a diretoria.", "Erro");
      return;
    }
    this.relogioPontoService.abrirModalIniciarJornada();
  }

  abrirModalRelogioPontoSaida() {
    this.FecharMenu();
    this.userLogado = this.authService.getUser();
    if (!this.podeRegistrarPonto()) {
      this.toastr.error("Para registrar o ponto é necessário estar vinculado a uma escola e diretoria, ou selecionar apenas a diretoria.", "Erro");
      return;
    }
    this.router.navigate(['/registro-saida'], { queryParams: { flow: 'checkout' } });
  }

  private podeRegistrarPonto(): boolean {
    const codigoDiretoria = this.userLogado?.codigoDiretoria ?? 0;
    if (codigoDiretoria == 0) {
      return false;
    }

    if (this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo) {
      return true;
    }

    return (this.userLogado?.codigoEscola != 0 && !this.userLogado?.apenasDiretoria)
      || ((this.userLogado?.codigoEscola == 0 || this.userLogado?.codigoEscola == null) && !!this.userLogado?.apenasDiretoria);
  }

  public async verificarAcessoCivicoMilitar(): Promise<void> {
    this.podeVisualizarCivicoMilitar = false;
    const perfisQuePodemVisualizarCivicoMilitar = [Perfil.DiretorEscolar, Perfil.ViceDiretor, Perfil.Monitor];
    try {
      const temEscolaCivicoMilitar = await possuiEscolaCivicoMilitarVinculada(this.userLogado, this.escolaService);
      const temPerfilQuePodemVisualizarCivicoMilitar = perfisQuePodemVisualizarCivicoMilitar.includes(this.userLogado!.codigoPerfil);
      this.podeVisualizarCivicoMilitar = (temEscolaCivicoMilitar && temPerfilQuePodemVisualizarCivicoMilitar) || this.userLogado!.codigoPerfil == Perfil.GestorConviva;
    } catch (error) {
      this.podeVisualizarCivicoMilitar = false;
    }
  }

  public ExpandirMenu(): void {

    this.expandir = true;
    const menu = document.getElementsByClassName("sidebar-menu").item(0) as HTMLElement;
    const bodyoverlay = document.getElementsByTagName("body").item(0) as HTMLElement;

    if (this.expandir) {
      menu.className = "sidebar-menu active";
      bodyoverlay.className = "overlay";
    } else {
      this.FecharMenu();
    }
  }

  public FecharMenu(): void {
    const menu = document.getElementsByClassName("sidebar-menu").item(0) as HTMLElement;
    menu.className = "sidebar-menu";

    const bodyoverlay = document.getElementsByTagName("body").item(0) as HTMLElement;
    bodyoverlay.className = " ";

    this.expandir = false;
  }


  public async logout() {

    this.FecharMenu();

    if (this.authService.hasTokenGovBr()) {
      await this.oauthService.loadDiscoveryDocument();
    } else {
      this.oauthService.configure(authConfigMasp);
    }

    this.authService.cleanStorageGovBr();
    this.authService.cleanStorageMasp();
    this.authService.cleanStorageConviva();
    if (this.oauthService.hasValidAccessToken()) {
      this.oauthService.logOut();
    }
    else {
      this.router.navigate(['/logout']);
    }
  }

  ngOnInit(): void {
    this.inicializar();
  }

  private async inicializar(): Promise<void> {
    this.userLogado = this.authService.getUser();
    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado.DadosUsuario[0];
    }

    this.IniciaStreamingNotificacoes();
    this.verificaParametrosAtivos();
    this.GetVersao();

    if (this.userLogado!.funcionalidades.length == 0) {
      try {
        const response = await lastValueFrom(
          this.perfilService.getFuncionalidadesPerfil(
            this.userLogado?.codigoPerfil ?? 0)
        );
        this.userLogado!.funcionalidades = response.data;
        this.spinnerService.hide();
      } catch (error) {
        this.ConvivaErrors.handleError(error);
        this.spinnerService.hide();
      }
    }

    await this.verificarPermissaoMenuPsicologos();
    await this.verificarPermissaoCivicoMilitar();

    if (this.userLogado?.DadosUsuario[0].CodigoPerfil == 1632)
      this.buscarAgendamentosCoordenador();

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart &&
        this.userLogado?.DadosUsuario[0].CodigoPerfil == 1632) {

        this.buscarAgendamentosCoordenador();
      }
    });

    this.verificarAcessoCivicoMilitar();
  }


  private async verificarPermissaoMenuPsicologos() {
    this.podeVisualizarMenuPsicologos =
    (this.userLogado?.funcionalidades?.includes(1) ?? false)
    || (this.userLogado?.funcionalidades?.includes(34) ?? false)
    || (this.userLogado?.funcionalidades?.includes(35) ?? false)
    || this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo
    || this.userLogado?.codigoPerfil == Perfil.GestorConviva
  }

  public navegarPlanoContingencia() {

    const codigoPerfil = this.userLogado?.DadosUsuario[0].CodigoPerfil;

    if ((codigoPerfil === Perfil.DiretorEscolar) || (codigoPerfil === Perfil.ViceDiretor)) {
      this.router.navigate(['/plano-contingencia/cadastro']);
    } else if (codigoPerfil === Perfil.PEC || codigoPerfil === Perfil.GestorConviva || codigoPerfil === Perfil.SupervisorEducacional) {
      this.router.navigate(['/plano-contingencia/consulta']);
    } else {
      this.toastr.warning("Perfil sem acesso ao Plano de Contingência");
      this.router.navigate(['/']);
    }

    this.FecharMenu();
  }


  async buscarAgendamentosCoordenador() {
    const objtEnvio = {
      codigoEscola: this.userLogado?.codigoEscola,
      codigoDiretoria: this.userLogado?.codigoDiretoria
    }
    const result = await lastValueFrom(this.agendamentoService.getAgendamentosEmAberto(objtEnvio));
    if (!result.isSucess) {
      this.toastr.error(result.message);
    } else {
      if (result.data > 0) {
        this.showModalAgendamento = true;
        this.quantidadeAgendamentosAbertos = result.data;
        // this.toastr.warning(`Existem ${result.data} agendamentos em aberto.`);

      }
    }
  }

  private IniciaStreamingNotificacoes() {

    setTimeout(() => {
      const filtros = this.setParametrosEventoNotificacao();
      this.notificacoesService.emitEventoNotificacoes(filtros);

      setInterval(() => {
        const filtros = this.setParametrosEventoNotificacao();
        this.notificacoesService.emitEventoNotificacoes(filtros);
      }, 60000); //A cada 1 minuto busca notificações
    }, 5000);//Espera o hub se conectar

  }

  private async GetVersao() {
    this.versao = environment.version;
  }

  private async verificaParametrosAtivos() {
    try {
      const response = await lastValueFrom(this.parametroPeriodoService.getAllParametroPeriodo());
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }

      const parametros = response.data;

      this.temPlanoContingenciaAtivo = parametros.some(
        (p: any) => p.codigoPlano === 1 && p.flAtivo
      );

      this.temPmceAtivo = parametros.some(
        (p: any) => p.codigoPlano === 2 && p.flAtivo
      );
    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    }
  }

  public setParametrosEventoNotificacao(): ListarEncaminhados {
    const chamado = new ListarEncaminhados();
    if (this.userLogado != null && this.userLogado.codigoDiretoria != null)
      chamado.codigoDiretoria = this.userLogado.codigoDiretoria;
    if (this.userLogado != null && this.userLogado.codigoEscola != null)
      chamado.codigoEscola = this.userLogado.codigoEscola;

    if (this.userLogado?.flPsicologo)
      chamado.perfil = this.userLogado.perfis[0].codigoPerfil;
    else
      chamado.perfil = this.userLogado!.DadosUsuario[0].CodigoPerfil;

    return chamado;
  }

  public SetParametrosChamados(): ListarChamados {
    const chamado = new ListarChamados();
    if (this.userLogado != null && this.userLogado.codigoDiretoria != null)
      chamado.codigoDiretoria = this.userLogado.codigoDiretoria;
    if (this.userLogado != null && this.userLogado.codigoEscola != null)
      chamado.codigoEscola = this.userLogado.codigoEscola;
    chamado.getFoto = false;
    return chamado;
  }
  FecharModalPopUp() {
    this.showModalAgendamento = false;
  }

  OpenModalChangePerfil() {
    this.showModalPerfil = true;
  }

  toggleSubMenu(menu: string) {
    this.activeSubMenus[menu] = !this.activeSubMenus[menu];
  }

  isSubMenuActive(menu: string): boolean {
    return this.activeSubMenus[menu];
  }

  FecharModalAgendamento() {
    this.showModalAgendamentoPsicologo = false;
    this.FecharMenu();
  }

  AbrirModalAgendamento() {
    this.showModalAgendamentoPsicologo = true;
  }

  mostrarConteudoParaPerfils(cdPerfis: number[]): boolean {
    return cdPerfis.includes(this.userLogado?.codigoPerfil!);
  }

  temFuncionalidade(codigos: number[]): boolean {
    return (this.userLogado?.funcionalidades || []).some(f => codigos.includes(f));
  }
}
